module.exports = __webpack_public_path__ + "static/media/icon_magnifier.a010ead8.svg";